var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-4" }, [
    _c("ul", { staticClass: "media-kit-menu" }, [
      _c(
        "li",
        { class: { active: _vm.currentRoute === "media-kit-brand-guideline" } },
        [
          _c("router-link", { attrs: { to: "/media-kit-brand-guideline" } }, [
            _vm._v("BRAND GUIDELINE")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { class: { active: _vm.currentRoute === "media-kit-visual-elements" } },
        [
          _c("router-link", { attrs: { to: "/media-kit-visual-elements" } }, [
            _vm._v("MEDIA GALLERY")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.currentRoute === "media-kit-sharing-templates" }
        },
        [
          _c("router-link", { attrs: { to: "/media-kit-sharing-templates" } }, [
            _vm._v("SHARING TEMPLATES")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { class: { active: _vm.currentRoute === "media-kit-written-content" } },
        [
          _c("router-link", { attrs: { to: "/media-kit-written-content" } }, [
            _vm._v("WRITTEN CONTENT")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { class: { active: _vm.currentRoute === "useful-resources" } },
        [
          _c("router-link", { attrs: { to: "/useful-resources" } }, [
            _vm._v("USEFUL GUIDES")
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "helpBtn" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.companyStrategyDetails.url &&
      _vm.companyStrategyDetails.status === "active"
        ? _c(
            "a",
            {
              attrs: { href: _vm.companyStrategyDetails.url, target: "_blank" }
            },
            [
              _c("img", {
                attrs: {
                  src: "/static/front/images/strategy-document-icon.svg",
                  alt: "alt"
                }
              }),
              _vm._v("\n      Your Strategy Document\n    ")
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { href: "https://help.b1g1.com/collection/1-members" } },
      [
        _c("img", {
          attrs: { src: "/static/front/images/question-icon.svg", alt: "alt" }
        }),
        _vm._v("\n      B1G1 Help Centre\n    ")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44b1ca85", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44b1ca85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/connect/MediaKitMenu.vue
// module id = null
// module chunks = 